<template>
  <vetster-button
    variant="secondaryOcean"
    :size="$screen('lg') ? 'base' : 'xs'"
    class="lg:!px-4"
    @click="$emit('click')"
  >
    <fa
      v-if="icon"
      :icon="icon"
      class="text-base fa-fw"
    />
    <span
      :data-testid="id"
      class="font-normal"
    >
      {{ label }}
    </span>
    <fa
      v-if="showRemove"
      :icon="['fas', 'xmark']"
      class="fa-fw ml-0.5"
    />
  </vetster-button>
</template>

<script>
export default {
  name: 'VetsterFilterButton',

  props: {
    id: {
      type: String,
      default: null,
    },
    icon: {
      type: Array,
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    showRemove: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['click'],
};
</script>
